<template>
  <b-container fluid class="headerPushDown voucherContainer">  
    <b-container class="voucherContainer">        
      <shop-category-panel ref="categoryPanel" v-bind:selectedCategory="currentSelectedCategory"/>
    </b-container>
  </b-container>
</template>

<script>
import ShopCategoryPanel from '@/components/ShopCategoryPanel'

export default {
    name: 'ShopCategoryView',
    components: {  
        ShopCategoryPanel, 
    },
    data () {
        return {
          currentSelectedCategory: undefined,
        }
    },
    methods: {

    },
    computed: {
        selectedCategory: function(){ /* returns Category ID*/
            return this.$route.params.id;
        }, 
        getLanguageItem: function() { 
          return this.$store.getters.getLanguageStrings;
        },    
    },
    beforeMount(){
      // set incoming initial group      
      this.currentSelectedCategory = this.selectedCategory;
    },
    beforeRouteUpdate (to, from, next) {
      // if id(parameter) changes, we need to reload the products of that group (does not happen on its own)
      //console.log('Route update: ', this.currentSelectedCategory , to.params.id);
      this.currentSelectedCategory = to.params.id;
      this.$refs.categoryPanel.loadProductsFromServer(this.currentSelectedCategory);
      
      next();
    },
    mounted(){
      this.$refs.categoryPanel.loadProductsFromServer(this.currentSelectedCategory);
      window.scroll({
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    }
}
</script>
